/**
 * Phase1CommerceSection — wraps the two new Fase 1G commerce CTAs
 * behind public feature flags. Renders nothing when both flags are off.
 *
 * Legacy €9,95 monitoring CTA in `ProductCard.js` is intentionally NOT
 * touched. This section sits alongside it.
 */
import EnergyControlCheckoutButton from './EnergyControlCheckoutButton';
import BroadScanCheckoutButton from './BroadScanCheckoutButton';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';

export default function Phase1CommerceSection({
  email = null,
  leadId = null,
  intakeId = null,
  refCode = null,
}) {
  const { flags, loading } = useFeatureFlags();
  if (loading) return null;
  if (!flags.ec_v2_checkout_enabled && !flags.broad_scan_checkout_enabled) {
    return null;
  }

  return (
    <section
      className="rounded-2xl border-2 border-primary/30 bg-primary/5 p-5 sm:p-6"
      data-testid="fase1-commerce-section"
    >
      <div className="text-[11px] uppercase tracking-wider font-semibold text-primary mb-3">
        Nieuwe Energy Control opties
      </div>
      <h3
        className="text-lg sm:text-xl font-semibold text-primary leading-snug"
        style={{ fontFamily: 'Outfit' }}
      >
        Direct starten met Powersure
      </h3>
      <p className="mt-1 text-[14px] text-foreground/80 leading-relaxed">
        Kies hieronder uw vervolgstap. Maandelijks opzegbaar. Geen besparingsgarantie.
      </p>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {flags.ec_v2_checkout_enabled && (
          <EnergyControlCheckoutButton
            enabled
            email={email}
            leadId={leadId}
            intakeId={intakeId}
            refCode={refCode}
          />
        )}
        {flags.broad_scan_checkout_enabled && (
          <BroadScanCheckoutButton
            enabled
            email={email}
            intakeId={intakeId}
            refCode={refCode}
          />
        )}
      </div>
    </section>
  );
}
